import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { OrderSettings, DeliveryTimeSettings } from 'PMT/entities/order';

//
// components
//
import TipTooltip from 'PMT/components/TipTooltip';
import FormGroupView from 'PMT/components/form/FormGroupView';
import NumberInput from 'PMT/components/form/NumberInput';
import OptionView from 'PMT/components/form/OptionView';

export default class DeliverySettingsPage extends Component {

  static propTypes = {
    orderSettings: PropTypes.instanceOf(OrderSettings).isRequired,

    deliveryTimeSettings: PropTypes.instanceOf(DeliveryTimeSettings).isRequired,

    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  get deliveryTimeSettings(): DeliveryTimeSettings {
    return this.props.orderSettings.deliverySettings.deliveryTimeSettings;
  }

  onChangeDeliveryTimeSettings = (deliveryTimeSettings) => {
    const orderSettings: OrderSettings = this.props.orderSettings;
    orderSettings.deliveryTimeSettings = deliveryTimeSettings;
    this.props.onChange(orderSettings);
  }

  //
  //
  //

  onTypeChange = (newType) => {
    const deliveryTimeSettings: DeliveryTimeSettings = this.deliveryTimeSettings;

    this.deliveryTimeSettings.settingsType = newType;

    this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
  };

  onDeliveryManArrivalTimeChange = (arrivalTime: number) => {
    const deliveryTimeSettings: DeliveryTimeSettings = this.deliveryTimeSettings;

    this.deliveryTimeSettings.adaptableTimeSettings.setDeliveryManArrivalTimeFromMinutes(arrivalTime);

    this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
  };

  onFixTimeChange = (time: number) => {
    const deliveryTimeSettings: DeliveryTimeSettings = this.deliveryTimeSettings;

    this.deliveryTimeSettings.fixTimeSettings.setTimeFromMinutes(time);

    this.onChangeDeliveryTimeSettings(deliveryTimeSettings);
  };

  //
  //
  //

  renderFixPart() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.delivery.delivery_time.fix.title')}
          <TipTooltip
            text={I18n.tr('order.settings.delivery.delivery_time.fix.title.tooltip')}
          />
        </FormGroupView.Label>
        <FormGroupView.Content>
          <div className="input-group">
            <NumberInput
              value={this.deliveryTimeSettings.fixTimeSettings.getTimeAsMinutes()}
              onChange={this.onFixTimeChange}
              disabled={this.props.readOnly}
            />
            <div className="input-group-addon">
              <label>{I18n.tr('global.minutes')}</label>
            </div>
          </div>
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  //
  //
  //

  renderAdaptablePart() {
    return (
      <div className="form-group">
        <div className="col-xs-4 control-label">
          <h4>
            <OptionView
              label={'2. Temps ajustable'}
              isActivated={this.deliveryTimeSettings.settingsType === DeliveryTimeSettings.Type.ADAPTABLE}
              onChange={() => this.onTypeChange(DeliveryTimeSettings.Type.ADAPTABLE)}
              readOnly={this.props.readOnly}
            />
          </h4>
        </div>
        <div className="col-xs-8 col-md-6 top-buffer-50">
          {this.renderManufactureDelay()}
          {this.renderDeliveryManArrivalTime()}
          {this.renderDeliveryTime()}
        </div>
      </div>
    );
  }

  renderManufactureDelay() {
    return (
      <div className="row">
        <div className="col-xs-4">
          a. Délai de production
          <TipTooltip
            text={'TODO'}
          />
        </div>
        <div className="col-xs-8">
          {this.props.orderSettings.getManufactureDelayAsMinutes()} {I18n.tr('global.minutes')}
        </div>
      </div>
    );
  }

  renderDeliveryManArrivalTime() {
    return (
      <div className="row top-buffer-30">
        <div className="col-xs-4">
          b. Délai d'arrivée du livreur
        </div>
        <div className="col-xs-8">
          <div className="input-group">
            <NumberInput
              value={this.deliveryTimeSettings.adaptableTimeSettings.getDeliveryManArrivalTimeAsMinutes()}
              onChange={this.onDeliveryManArrivalTimeChange}
              disabled={this.props.readOnly}
            />
            <div className="input-group-addon">
              <label>{I18n.tr('global.minutes')}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderDeliveryTime() {
    return (
      <div className="row top-buffer-30">
        <div className="col-xs-4">
          c. Temps de livraison
        </div>
        <div className="col-xs-8">
          Calculé automatiquement
        </div>
      </div>
    );
  }

  //
  //
  //

  render() {
    return (
      <div
        className="delivery_time_settings_view"
      >
        {this.renderFixPart()}
        {/* {this.renderAdaptablePart()} */}
      </div>
    );
  }
}
